'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.receivedPubNubPresence = exports.chatInputChanged = exports.leaveChannels = exports.leaveChannel = exports.updateTypingState = exports.sendTypingState = exports.setShowTypingIndicator = undefined;
exports.receivedTypingState = receivedTypingState;

var _reduxActions = require('redux-actions');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _RoleTypes = require('conversations-schema/constants/RoleTypes');

var _RoleTypes2 = _interopRequireDefault(_RoleTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setShowTypingIndicator = exports.setShowTypingIndicator = (0, _reduxActions.createAction)(_ActionTypes2.default.SET_SHOW_TYPING_INDICATOR);

var sendTypingState = exports.sendTypingState = (0, _reduxActions.createAction)(_ActionTypes2.default.SEND_TYPING_STATE);

var updateTypingState = exports.updateTypingState = (0, _reduxActions.createAction)(_ActionTypes2.default.UPDATE_TYPING_STATE);

var leaveChannel = exports.leaveChannel = (0, _reduxActions.createAction)(_ActionTypes2.default.LEAVE_CHANNEL, function (channel) {
  return { channel: channel };
});

var leaveChannels = exports.leaveChannels = (0, _reduxActions.createAction)(_ActionTypes2.default.LEAVE_CHANNELS);

function receivedTypingState(whosTyping, isAdmin) {
  return function (dispatch) {
    dispatch(updateTypingState(whosTyping));
    if (isAdmin) {
      dispatch(setShowTypingIndicator(whosTyping.includes(_RoleTypes2.default.VISITOR)));
    } else {
      dispatch(setShowTypingIndicator(whosTyping.includes(_RoleTypes2.default.REP)));
    }
  };
}

var chatInputChanged = exports.chatInputChanged = (0, _reduxActions.createAction)(_ActionTypes2.default.CHAT_INPUT_CHANGED);

var receivedPubNubPresence = exports.receivedPubNubPresence = (0, _reduxActions.createAction)(_ActionTypes2.default.RECEIVED_PUBNUB_PRESENCE);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/actions/PubNubPresenceActions.js
// module id = 67
// module chunks = 0 1